import { Card } from '../../../../../../components/card/card';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import { hasService } from '../../../../../../helpers/local-storage';
import { serviceMap, ServiceType } from '../../../../../../helpers/services';
import s from './qr-services.module.css';
import { useQrServices } from './use-qr-services';

export const QrServices = () => {
  const { qr, handleChangeServices, t } = useQrServices();

  return (
    <Card className={s.feature} title={`2. ${t('Сервисы')}`}>
      <label>{t('Отображать сервисы')}</label>
      <ul className={s.list}>
        {Object.keys(serviceMap)
          .filter((key) => hasService(key as ServiceType))
          .map((key) => (
            <Checkbox
              key={key}
              label={t(serviceMap[key as ServiceType])}
              checked={qr?.services?.includes(key as ServiceType)}
              onClick={() => handleChangeServices(key as ServiceType)}
              id={`check-${key}`}
            />
          ))}
      </ul>
    </Card>
  );
};
